var _path, _rect, _rect2, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGsbIconHousewaresElectronic = function SvgGsbIconHousewaresElectronic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.37,65.77,179.2,20.6,134,65.77,122,53.7l51.2-51.2a8.53,8.53,0,0,1,12.06,0l51.2,51.2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.13,
    y: 486.4,
    width: 17.07,
    height: 25.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 307.2,
    y: 486.4,
    width: 17.07,
    height: 25.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 418.13,
    y: 162.13,
    width: 17.07,
    height: 307.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 469.33,
    width: 85.33,
    height: 34.13
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.13,204.8H68.27a8.54,8.54,0,0,1-8.54-8.53V59.73a8.54,8.54,0,0,1,8.54-8.53H290.13a8.54,8.54,0,0,1,8.54,8.53V196.27A8.54,8.54,0,0,1,290.13,204.8ZM76.8,187.73H281.6V68.27H76.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53,494.93h25.6V512H51.2V494.93h256V512h17.07V494.93h25.6a8.53,8.53,0,0,0,8.53-8.53V349.87a8.54,8.54,0,0,0-8.53-8.54h-25.6V247.47a8.55,8.55,0,0,0-8.54-8.54H42.67a8.55,8.55,0,0,0-8.54,8.54v93.86H8.53A8.54,8.54,0,0,0,0,349.87V486.4A8.53,8.53,0,0,0,8.53,494.93ZM256,477.87H102.4V409.6H256ZM341.33,358.4V477.87H273.07V358.4ZM51.2,256h256v85.33H264.53a8.54,8.54,0,0,0-8.53,8.54v42.66H102.4V349.87a8.54,8.54,0,0,0-8.53-8.54H51.2ZM17.07,358.4H85.33V477.87H17.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M349.87,170.67h68.26V460.8H384a8.53,8.53,0,0,0-8.53,8.53v34.14A8.53,8.53,0,0,0,384,512h85.33a8.54,8.54,0,0,0,8.54-8.53V469.33a8.54,8.54,0,0,0-8.54-8.53H435.2V170.67h68.27a8.54,8.54,0,0,0,8.53-8.54c0-.31,0-.63-.05-.93L494.88,7.6A8.53,8.53,0,0,0,486.4,0H366.93a8.53,8.53,0,0,0-8.48,7.59L341.38,161.2a8.54,8.54,0,0,0,7.55,9.42C349.23,170.65,349.55,170.67,349.87,170.67ZM460.8,477.87v17.06H392.53V477.87ZM374.61,17.07H478.8L494,153.6H359.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.27,204.8H290.13a8.54,8.54,0,0,0,8.54-8.53V59.73a8.54,8.54,0,0,0-8.54-8.53h-56.2L185.23,2.5a8.53,8.53,0,0,0-12.06,0l-48.7,48.7H68.27a8.54,8.54,0,0,0-8.54,8.53V196.27A8.54,8.54,0,0,0,68.27,204.8ZM179.2,20.6l30.6,30.6H148.6ZM76.8,68.27H281.6V187.73H76.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.87,170.67H264.53V85.33H93.87Zm17.06-68.27H247.47v51.2H110.93Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGsbIconHousewaresElectronic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gsb-iconHousewares&Electronic.20c29e56.svg";
export { ForwardRef as ReactComponent };